import { Card, Icon, Text } from '@planningcenter/tapestry-react';
import React from 'react';

const ErrorCard = ({ message, ...props }) => (React.createElement(Card, { axis: "horizontal", backgroundColor: "error-lighter", borderColor: "error-lighter", padding: 2, spacing: 1, width: "auto", ...props },
    React.createElement(Icon, { name: "general.exclamationTriangle", color: "error", marginTop: 0.5 }),
    React.createElement(Text, { size: 4 }, message)));

export { ErrorCard };
//# sourceMappingURL=error_card.js.map
